export const gateway = 
[
  {
      "휴게소명": "황간(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.249437,
      "경도": 127.854835,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 32652,
      "주차면수": 118,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "영표국밥＆솥밥",
      "휴게소전화번호": "043-742-7633",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "황전(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 27,
      "도로노선명": "순천완주선",
      "도로노선방향": "하행",
      "위도": 35.148905,
      "경도": 127.454145,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 26097,
      "주차면수": 154,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "고소한 수제돈가스+남도식국물잡채",
      "휴게소전화번호": "061-782-1135",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "황전(완주)",
      "도로종류": "고속국도",
      "도로노선번호": 27,
      "도로노선명": "순천완주선",
      "도로노선방향": "상행",
      "위도": 35.153306,
      "경도": 127.454683,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 34013,
      "주차면수": 121,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "황전해초꼬막비빔밥+재첩국",
      "휴게소전화번호": "061-782-1154",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "횡성(강릉)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "하행",
      "위도": 37.462755,
      "경도": 128.133969,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 47509,
      "주차면수": 291,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "횡성한우떡더덕스테이크",
      "휴게소전화번호": "033-342-4231",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "횡성(인천)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "상행",
      "위도": 37.464983,
      "경도": 128.135449,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 37474,
      "주차면수": 246,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "횡성더덕설렁탕",
      "휴게소전화번호": "033-342-4200",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "문경(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "하행",
      "위도": 36.620549,
      "경도": 128.149982,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 58347,
      "주차면수": 272,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "곤드레비빔밥",
      "휴게소전화번호": "054-554-1655",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "문막(강릉)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "하행",
      "위도": 37.335469,
      "경도": 127.8582201,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 74440,
      "주차면수": 250,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "Y",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "강릉식 순두부찌개",
      "휴게소전화번호": "033-731-8481",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "문막(인천)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "상행",
      "위도": 37.297853,
      "경도": 127.817261,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42780,
      "주차면수": 213,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "소한마리탕",
      "휴게소전화번호": "033-747-8162",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "문산(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "하행",
      "위도": 35.171374,
      "경도": 128.151591,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 18397,
      "주차면수": 232,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "엄마손된장찌개",
      "휴게소전화번호": "055-761-2820",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "문의청남대(영덕)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "하행",
      "위도": 36.542544,
      "경도": 127.483797,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 52200,
      "주차면수": 150,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "파채제육덮밥",
      "휴게소전화번호": "043-715-2820",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "문의청남대(청주)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "상행",
      "위도": 36.544083,
      "경도": 127.484613,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 31030,
      "주차면수": 148,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "버섯불고기정식",
      "휴게소전화번호": "043-223-2820",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "백양사(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 35.394425,
      "경도": 126.805361,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29681,
      "주차면수": 73,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "삼채된장찌개+불고기돌솥비빔밥",
      "휴게소전화번호": "061-394-9990",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "백양사(천안)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "상행",
      "위도": 35.393018,
      "경도": 126.807376,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 27840,
      "주차면수": 74,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "삼채애호박찌개+녹차굴비백반",
      "휴게소전화번호": "061-394-5177",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "벌곡(논산)",
      "도로종류": "고속국도",
      "도로노선번호": 251,
      "도로노선명": "호남지선",
      "도로노선방향": "하행",
      "위도": 36.217974,
      "경도": 127.273468,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 24628,
      "주차면수": 133,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "벌곡닭갈비",
      "휴게소전화번호": "041-732-7694",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "벌곡(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 251,
      "도로노선명": "호남지선",
      "도로노선방향": "상행",
      "위도": 36.210451,
      "경도": 127.270542,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 27411,
      "주차면수": 149,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "촌돼지찌개",
      "휴게소전화번호": "041-734-5250",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "보성녹차(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "하행",
      "위도": 34.807313,
      "경도": 127.181003,
      "휴게소종류": "간이휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 41433,
      "주차면수": 113,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "보성꼬막비빔밥+애호박고추장찌개",
      "휴게소전화번호": "070-4325-8808",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "보성녹차(영암)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "상행",
      "위도": 34.807313,
      "경도": 127.181003,
      "휴게소종류": "간이휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 71199,
      "주차면수": 74,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "보성꼬막비빔밥+애호박고추장찌개",
      "휴게소전화번호": "070-4325-8801",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "부안고려청자(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 35.671628,
      "경도": 126.732073,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 72611,
      "주차면수": 158,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "부안오디돈까스",
      "휴게소전화번호": "063-776-8003",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "부안고려청자(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 35.671598,
      "경도": 126.734592,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 21205,
      "주차면수": 157,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "부안오디돈까스",
      "휴게소전화번호": "063-776-7002",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "부여백제(공주)",
      "도로종류": "고속국도",
      "도로노선번호": 151,
      "도로노선명": "서천공주선",
      "도로노선방향": "상행",
      "위도": 36.258352,
      "경도": 126.8000701,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 30117,
      "주차면수": 90,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "표고버섯 된장찌개",
      "휴게소전화번호": "041-833-5400",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "부여백제(서천)",
      "도로종류": "고속국도",
      "도로노선번호": 151,
      "도로노선명": "서천공주선",
      "도로노선방향": "하행",
      "위도": 36.258383,
      "경도": 126.796755,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 30853,
      "주차면수": 99,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "얼큰 순두부찌개",
      "휴게소전화번호": "041-834-5600",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "사천(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "상행",
      "위도": 35.073173,
      "경도": 128.010802,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 26830,
      "주차면수": 178,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "건강버섯두부덮밥",
      "휴게소전화번호": "055-854-3134",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "사천(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "하행",
      "위도": 35.074968,
      "경도": 128.012589,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 61600,
      "주차면수": 192,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "건강버섯두부덮밥",
      "휴게소전화번호": "055-854-3547",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "산청(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "상행",
      "위도": 35.333522,
      "경도": 127.938998,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 53378,
      "주차면수": 170,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한방우불고기",
      "휴게소전화번호": "055-973-5970",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "산청(통영)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "하행",
      "위도": 35.333504,
      "경도": 127.937049,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 58111,
      "주차면수": 130,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한방우불고기",
      "휴게소전화번호": "055-973-9036",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "서산(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 36.742991,
      "경도": 126.565029,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 51095,
      "주차면수": 253,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "어리굴젓백반",
      "휴게소전화번호": "041-688-8814",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "서산(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 36.734194,
      "경도": 126.566302,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 13845,
      "주차면수": 197,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "불향제육덮밥",
      "휴게소전화번호": "041-688-7714",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "서여주(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙",
      "도로노선방향": "상행",
      "위도": 37.278607,
      "경도": 127.580501,
      "휴게소종류": "간이휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 57948,
      "주차면수": 75,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "조개살된장찌개",
      "휴게소전화번호": "031-885-9760",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "서여주(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙",
      "도로노선방향": "하행",
      "위도": 37.279412,
      "경도": 127.578083,
      "휴게소종류": "간이휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 54919,
      "주차면수": 70,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "콩나물황태해장국",
      "휴게소전화번호": "031-884-9714",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "서울만남(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 37.460166,
      "경도": 127.041908,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 32460,
      "주차면수": 262,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "말죽거리소고기국밥",
      "휴게소전화번호": "02-578-3372",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "서천(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 36.129505,
      "경도": 126.626485,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28943,
      "주차면수": 152,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "동죽해물된장찌개",
      "휴게소전화번호": "041-952-5757",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "서천(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 36.131929,
      "경도": 126.627834,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 18130,
      "주차면수": 200,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "사골들깨순두부",
      "휴게소전화번호": "041-952-9700",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "선산(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "상행",
      "위도": 36.277941,
      "경도": 128.249296,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 15454,
      "주차면수": 208,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "묵은지김치찌개",
      "휴게소전화번호": "054-482-6011",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "선산(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "하행",
      "위도": 36.274223,
      "경도": 128.250745,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 38848,
      "주차면수": 265,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "능이버섯육개장",
      "휴게소전화번호": "054-482-6031",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "섬진강(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "상행",
      "위도": 34.9847001,
      "경도": 127.770697,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 38631,
      "주차면수": 141,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "재첩국+광양 뚝배기불고기",
      "휴게소전화번호": "061-772-7986",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "섬진강(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 34.985669,
      "경도": 127.769329,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 53607,
      "주차면수": 191,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "청매실 재첩비빔밥+얼큰 순두부찌개",
      "휴게소전화번호": "061-772-7993",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "성주(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "상행",
      "위도": 36.0082601,
      "경도": 128.261541,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 23306,
      "주차면수": 188,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "고추장제육볶음",
      "휴게소전화번호": "054-933-0800",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "성주(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "하행",
      "위도": 36.010603,
      "경도": 128.259675,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 16700,
      "주차면수": 188,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "참외 고추장 비빔밥",
      "휴게소전화번호": "054-932-0800",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "속리산(청주)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "상행",
      "위도": 36.447804,
      "경도": 127.869061,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 63846,
      "주차면수": 189,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "보은대추영양솥밥",
      "휴게소전화번호": "043-544-1466",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "순천(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 35.0085501,
      "경도": 127.445044,
      "휴게소종류": "간이휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42822,
      "주차면수": 44,
      "경정비가능여부": "N",
      "주유소유무": "N",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "함평 추어탕+육개장",
      "휴게소전화번호": "061-755-4982",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "시흥하늘",
      "도로종류": "고속국도",
      "도로노선번호": 100,
      "도로노선명": "수도권제1순환선",
      "도로노선방향": "양방향",
      "위도": 37.383794,
      "경도": 126.855452,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 40874,
      "주차면수": 560,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "Y",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "등심스테이크",
      "휴게소전화번호": "031-481-9757",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "신탄진(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.426834,
      "경도": 127.418438,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28974,
      "주차면수": 342,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "도가니설렁탕",
      "휴게소전화번호": "042-934-2442",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "안동(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "하행",
      "위도": 36.553167,
      "경도": 128.641923,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 85692,
      "주차면수": 182,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "안동간고등어정식",
      "휴게소전화번호": "054-853-4370",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "안동(춘천)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "상행",
      "위도": 36.5534301,
      "경도": 128.645144,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 66492,
      "주차면수": 155,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "안동간고등어정식",
      "휴게소전화번호": "054-853-4061",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "안산",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "양방향",
      "위도": 37.351075,
      "경도": 126.818799,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 59766,
      "주차면수": 440,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "충청도식 돼지짜글이 정식",
      "휴게소전화번호": "031-482-7775",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "안성(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 37.013407,
      "경도": 127.1448001,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 35779,
      "주차면수": 391,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "안성국밥",
      "휴게소전화번호": "031-655-0531",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "안성(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 37.076681,
      "경도": 127.132496,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 27816,
      "주차면수": 348,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "안성자연마춤한우국밥",
      "휴게소전화번호": "031-611-5793",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "안성맞춤(제천)",
      "도로종류": "고속국도",
      "도로노선번호": 40,
      "도로노선명": "평택제천선",
      "도로노선방향": "하행",
      "위도": 36.968057,
      "경도": 127.274261,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 51744,
      "주차면수": 173,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "안성맞춤한우국밥",
      "휴게소전화번호": "031-674-4406",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "안성맞춤(평택)",
      "도로종류": "고속국도",
      "도로노선번호": 40,
      "도로노선명": "평택제천선",
      "도로노선방향": "상행",
      "위도": 36.969915,
      "경도": 127.274619,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28050,
      "주차면수": 171,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "안성맞춤국밥",
      "휴게소전화번호": "031-673-3822",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "양산(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 35.323172,
      "경도": 129.056867,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 52610,
      "주차면수": 177,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "묵은지돼지갈비찜",
      "휴게소전화번호": "055-384-0144",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "언양(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 35.597942,
      "경도": 129.141801,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 47973,
      "주차면수": 236,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "묵은지김치찌개",
      "휴게소전화번호": "052-263-6153",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "여산(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 36.048555,
      "경도": 127.102333,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 20609,
      "주차면수": 222,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "미륵산해물순두부",
      "휴게소전화번호": "063-836-5280",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "여산(천안)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "상행",
      "위도": 36.048528,
      "경도": 127.104716,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 80288,
      "주차면수": 197,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "서동마여산양파제육불고기",
      "휴게소전화번호": "063-836-5168",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "여주(강릉)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "하행",
      "위도": 37.238022,
      "경도": 127.568892,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 74442,
      "주차면수": 404,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "용대리황태해장국",
      "휴게소전화번호": "031-882-3120",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "여주(인천)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "상행",
      "위도": 37.239739,
      "경도": 127.569949,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 66423,
      "주차면수": 249,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "매운돼지갈비찜",
      "휴게소전화번호": "031-882-2900",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "영산(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 451,
      "도로노선명": "중부내륙지선",
      "도로노선방향": "하행",
      "위도": 35.429794,
      "경도": 128.495915,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 62787,
      "주차면수": 136,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "창녕양파제육정식",
      "휴게소전화번호": "055-521-2978",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "영천(대구)",
      "도로종류": "고속국도",
      "도로노선번호": 20,
      "도로노선명": "대구포항선",
      "도로노선방향": "하행",
      "위도": 36.053254,
      "경도": 129.044422,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 57978,
      "주차면수": 298,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "영천돼지짜글이",
      "휴게소전화번호": "054-338-0037",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "영천(포항)",
      "도로종류": "고속국도",
      "도로노선번호": 20,
      "도로노선명": "대구포항선",
      "도로노선방향": "상행",
      "위도": 36.051451,
      "경도": 129.042544,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 44883,
      "주차면수": 266,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "영천뽕잎얼갈이해장국",
      "휴게소전화번호": "054-338-0062",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "예산(당진)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "하행",
      "위도": 36.619429,
      "경도": 126.846389,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 11001,
      "주차면수": 187,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "사과돈가스",
      "휴게소전화번호": "041-335-0020",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "예산(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "상행",
      "위도": 36.6234601,
      "경도": 126.839619,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 16297,
      "주차면수": 195,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한방돼지국밥",
      "휴게소전화번호": "041-334-0094",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "오수(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 27,
      "도로노선명": "순천완주선",
      "도로노선방향": "하행",
      "위도": 35.540925,
      "경도": 127.309267,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 70390,
      "주차면수": 216,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "임실치즈 매콤돈까스+임실치즈 식물성제육철판볶음밥",
      "휴게소전화번호": "063-644-6116",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "정읍녹두장군(천안)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "상행",
      "위도": 35.599975,
      "경도": 126.864336,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29312,
      "주차면수": 172,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "정읍국밥",
      "휴게소전화번호": "063-532-2373",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "오수(완주)",
      "도로종류": "고속국도",
      "도로노선번호": 27,
      "도로노선명": "순천완주선",
      "도로노선방향": "상행",
      "위도": 35.540271,
      "경도": 127.311622,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 33272,
      "주차면수": 183,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "임실치즈 매콤돈까스+임실치즈 식물성불고기철판볶음밥",
      "휴게소전화번호": "063-644-5115",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "오창(남이)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "하행",
      "위도": 36.758481,
      "경도": 127.481777,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 43421,
      "주차면수": 134,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "능이버섯인삼설렁탕",
      "휴게소전화번호": "043-217-1477",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "오창(하남)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "상행",
      "위도": 36.756581,
      "경도": 127.481909,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 25278,
      "주차면수": 191,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "등심돈가스",
      "휴게소전화번호": "043-217-8303",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "옥계(속초)",
      "도로종류": "고속국도",
      "도로노선번호": 65,
      "도로노선명": "동해선",
      "도로노선방향": "상행",
      "위도": 37.616198,
      "경도": 129.060129,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 45218,
      "주차면수": 156,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "막국수",
      "휴게소전화번호": "033-534-1700",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "옥산(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.657743,
      "경도": 127.369817,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 41484,
      "주차면수": 232,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "화덕고추장삼겹살",
      "휴게소전화번호": "043-260-1053",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "옥천(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.296863,
      "경도": 127.595223,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 27498,
      "주차면수": 177,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "숯불고기비빔밥",
      "휴게소전화번호": "043-731-8521",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "옥천(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.297616,
      "경도": 127.598777,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29069,
      "주차면수": 147,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한방닭곰탕",
      "휴게소전화번호": "043-731-8097",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "옥천만남",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "양방향",
      "위도": 36.308718,
      "경도": 127.572308,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 33223,
      "주차면수": 212,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "N",
      "매점유무": "Y",
      "음식점유무": "N",
      "기타편의시설": "",
      "휴게소대표음식명": "없음",
      "휴게소전화번호": "043-732-0081",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "와촌(포항)",
      "도로종류": "고속국도",
      "도로노선번호": 20,
      "도로노선명": "대구포항선",
      "도로노선방향": "상행",
      "위도": 35.951819,
      "경도": 128.775563,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 32862,
      "주차면수": 141,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "대추고추장비빔밥",
      "휴게소전화번호": "053-853-1002",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "외동(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 65,
      "도로노선명": "울산포항선",
      "도로노선방향": "하행",
      "위도": 35.672753,
      "경도": 129.285277,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 86844,
      "주차면수": 73,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "장터국밥",
      "휴게소전화번호": "054-745-0637",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "외동(포항)",
      "도로종류": "고속국도",
      "도로노선번호": 65,
      "도로노선명": "울산포항선",
      "도로노선방향": "상행",
      "위도": 35.672847,
      "경도": 129.288543,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 86844,
      "주차면수": 72,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "천년한우국밥",
      "휴게소전화번호": "054-745-0631",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "용인(강릉)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "하행",
      "위도": 37.245583,
      "경도": 127.2419801,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 48897,
      "주차면수": 313,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "소고기국밥",
      "휴게소전화번호": "031-339-3663",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "용인(인천)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "상행",
      "위도": 37.248318,
      "경도": 127.238342,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42927,
      "주차면수": 169,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "콩고기더덕돌솥비빔밥",
      "휴게소전화번호": "031-339-3660",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "울주(울산)",
      "도로종류": "고속국도",
      "도로노선번호": 14,
      "도로노선명": "밀양울산선",
      "도로노선방향": "상행",
      "위도": 35.510821,
      "경도": 129.130435,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 32496,
      "주차면수": 159,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "돼지갈비정식",
      "휴게소전화번호": "052-977-3243",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "울주(함양)",
      "도로종류": "고속국도",
      "도로노선번호": 14,
      "도로노선명": "밀양울산선",
      "도로노선방향": "하행",
      "위도": 35.5131601,
      "경도": 129.128519,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 77783,
      "주차면수": 208,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "고등어구이",
      "휴게소전화번호": "052-933-5242",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "원주(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "하행",
      "위도": 37.435194,
      "경도": 127.929063,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 43895,
      "주차면수": 163,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한우국밥",
      "휴게소전화번호": "033-731-4291",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "원주(춘천)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "상행",
      "위도": 37.434542,
      "경도": 127.931768,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 19101,
      "주차면수": 141,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한돈고추장불고기",
      "휴게소전화번호": "033-731-8194",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "음성(남이)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "하행",
      "위도": 37.019638,
      "경도": 127.480712,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 16237,
      "주차면수": 333,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "우거지별난국밥",
      "휴게소전화번호": "043-878-6410",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "음성(하남)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "상행",
      "위도": 37.022065,
      "경도": 127.484315,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 27508,
      "주차면수": 248,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "음성인삼설렁탕",
      "휴게소전화번호": "043-878-6403",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "의성(영덕)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "상주영덕선",
      "도로노선방향": "하행",
      "위도": 36.409501,
      "경도": 128.447699,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29463,
      "주차면수": 72,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "의성마늘곰탕",
      "휴게소전화번호": "054-862-9252",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "의성(청주)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "상주영덕선",
      "도로노선방향": "상행",
      "위도": 36.410954,
      "경도": 128.4447101,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 82868,
      "주차면수": 67,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "의성마늘육개장",
      "휴게소전화번호": "054-862-9076",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "이서(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 35.803936,
      "경도": 127.023705,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 70002,
      "주차면수": 91,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "명품꼬막비빔밥",
      "휴게소전화번호": "063-227-4114",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "이서(천안)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "상행",
      "위도": 35.801932,
      "경도": 127.025759,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 81553,
      "주차면수": 90,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "명품애호박국밥",
      "휴게소전화번호": "063-236-2592",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "이천(남이)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "하행",
      "위도": 37.264574,
      "경도": 127.403687,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 41925,
      "주차면수": 126,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "장터국밥",
      "휴게소전화번호": "031-637-0987",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "이천(하남)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "상행",
      "위도": 37.293979,
      "경도": 127.378203,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 17409,
      "주차면수": 238,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "영양돌솥비빔밥",
      "휴게소전화번호": "031-638-1117",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "입장거봉포도(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.942997,
      "경도": 127.192467,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 40011,
      "주차면수": 350,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "입장거봉포도돈까스",
      "휴게소전화번호": "041-588-7868",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "장유(서부산)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "하행",
      "위도": 35.212074,
      "경도": 128.7935801,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28126,
      "주차면수": 107,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "통영해물순두부찌개",
      "휴게소전화번호": "055-313-2610",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "장흥정남진",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "양방향",
      "위도": 34.720894,
      "경도": 126.931319,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28705,
      "주차면수": 116,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "장�V표고뚝배기불고기+순두부찌개",
      "휴게소전화번호": "061-864-5007",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "정읍녹두장군(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 35.601465,
      "경도": 126.862006,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 25780,
      "주차면수": 145,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "녹두장군오리탕",
      "휴게소전화번호": "063-532-0510",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "주암(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 35.076197,
      "경도": 127.2641001,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 18860,
      "주차면수": 99,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한우파개장+해물순두부",
      "휴게소전화번호": "061-754-4980",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "주암(천안)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "상행",
      "위도": 35.076587,
      "경도": 127.265762,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28982,
      "주차면수": 124,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "오.쭈.삼 철판볶음+제육볶음",
      "휴게소전화번호": "061-754-2432",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
//   {
//       "휴게소명": "죽암(부산)",
//       "도로종류": "고속국도",
//       "도로노선번호": 1,
//       "도로노선명": "경부선",
//       "도로노선방향": "하행",
//       "위도": 36.4868101,
//       "경도": 127.429261,
//       "휴게소종류": "일반휴게소",
//       "휴게소운영시작시각": "00:00",
//       "휴게소운영종료시각": "23:59",
//       "도로점용면적": 40224,
//       "주차면수": 235,
//       "경정비가능여부": "N",
//       "주유소유무": "Y",
//       "LPG충전소유무": "Y",
//       "전기차충전소유무": "Y",
//       "버스환승가능여부": "N",
//       "쉼터유무": "N",
//       "화장실유무": "Y",
//       "약국유무": "N",
//       "수유실유무": "Y",
//       "매점유무": "Y",
//       "음식점유무": "Y",
//       "기타편의시설": "",
//       "휴게소대표음식명": "보은대추왕갈비탕",
//       "휴게소전화번호": "043-269-0850",
//       "데이터기준일자": "2024-05-24",
//       "제공기관코드": "B500004",
//       "제공기관명": "한국도로공사"
//   },
  {
      "휴게소명": "죽암(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.496775,
      "경도": 127.4306501,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 61516,
      "주차면수": 208,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "돌솥비빔밥",
      "휴게소전화번호": "043-260-8035",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "죽전(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 37.332371,
      "경도": 127.104795,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 53532,
      "주차면수": 229,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "용인특산품영양밥정식",
      "휴게소전화번호": "031-262-3168",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "지리산(광주)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "하행",
      "위도": 35.483942,
      "경도": 127.567106,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 50251,
      "주차면수": 145,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "춘향돌솥추어탕+화덕고등어구이",
      "휴게소전화번호": "063-636-7195",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "지리산(대구)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "상행",
      "위도": 35.481353,
      "경도": 127.566804,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 22194,
      "주차면수": 107,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "춘향돌솥추어탕+화덕고등어구이",
      "휴게소전화번호": "063-636-7191",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "진안마이산(익산)",
      "도로종류": "고속국도",
      "도로노선번호": 20,
      "도로노선명": "익산장수선",
      "도로노선방향": "하행",
      "위도": 35.777898,
      "경도": 127.425279,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 31124,
      "주차면수": 84,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "흑돼지고추장찌개",
      "휴게소전화번호": "063-432-1380",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "진안마이산(장수)",
      "도로종류": "고속국도",
      "도로노선번호": 20,
      "도로노선명": "익산장수선",
      "도로노선방향": "상행",
      "위도": 35.7748201,
      "경도": 127.426362,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 93523,
      "주차면수": 84,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "흑돼지돈까스",
      "휴게소전화번호": "063-432-6350",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "진영(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "상행",
      "위도": 35.2779101,
      "경도": 128.715388,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28016,
      "주차면수": 602,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "진영소국밥",
      "휴게소전화번호": "055-334-8700",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "진영(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "하행",
      "위도": 35.280059,
      "경도": 128.716044,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 16876,
      "주차면수": 433,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "장군차갈비찜",
      "휴게소전화번호": "055-342-3959",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "진주(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "상행",
      "위도": 35.159772,
      "경도": 128.1220101,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 26533,
      "주차면수": 199,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "진주육전비빔밥",
      "휴게소전화번호": "055-759-3205",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "천등산(제천)",
      "도로종류": "고속국도",
      "도로노선번호": 40,
      "도로노선명": "평택제천선",
      "도로노선방향": "하행",
      "위도": 37.061597,
      "경도": 127.939378,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 17803,
      "주차면수": 122,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "천등산고추장짜글이",
      "휴게소전화번호": "043-844-2991",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "천등산(평택)",
      "도로종류": "고속국도",
      "도로노선번호": 40,
      "도로노선명": "평택제천선",
      "도로노선방향": "상행",
      "위도": 37.076872,
      "경도": 127.989171,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 6394,
      "주차면수": 110,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "우렁순두부찌개",
      "휴게소전화번호": "043-844-2930",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "천안삼거리(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.787809,
      "경도": 127.173455,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 6014,
      "주차면수": 271,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "Y",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "해주비빔밥",
      "휴게소전화번호": "041-551-2480",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "천안호두(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.730226,
      "경도": 127.263879,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 23402,
      "주차면수": 224,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "아우네병천순대국밥",
      "휴게소전화번호": "041-552-4560",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "청송(영덕)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "상주영덕선",
      "도로노선방향": "상행",
      "위도": 36.455725,
      "경도": 129.0131901,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 47354,
      "주차면수": 80,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "청송사과돈가스",
      "휴게소전화번호": "054-873-9102",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "청송(청주)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "상주영덕선",
      "도로노선방향": "하행",
      "위도": 36.456721,
      "경도": 129.012028,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 16546,
      "주차면수": 75,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "청송사과돈가스",
      "휴게소전화번호": "054-873-5911",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "청주(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.716005,
      "경도": 127.349315,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 89093,
      "주차면수": 280,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "솥밥통마늘제육정식",
      "휴게소전화번호": "043-237-1700",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "청통(대구)",
      "도로종류": "고속국도",
      "도로노선번호": 20,
      "도로노선명": "대구포항선",
      "도로노선방향": "하행",
      "위도": 35.993928,
      "경도": 128.859145,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 46378,
      "주차면수": 158,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "차돌된장찌개",
      "휴게소전화번호": "054-337-5009",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "추풍령(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.200356,
      "경도": 128.000331,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 70169,
      "주차면수": 213,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "얼큰칼제비",
      "휴게소전화번호": "054-430-2000",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "추풍령(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.199708,
      "경도": 128.003242,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 63390,
      "주차면수": 160,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "김천지례석쇠불고기",
      "휴게소전화번호": "054-439-3187",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "춘천(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "하행",
      "위도": 37.8126801,
      "경도": 127.766078,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 45696,
      "주차면수": 105,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "춘천버섯닭갈비정식",
      "휴게소전화번호": "033-264-0500",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "춘향(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 27,
      "도로노선명": "순천완주선",
      "도로노선방향": "하행",
      "위도": 35.3367566,
      "경도": 127.3515503,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 61992,
      "주차면수": 154,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "향단이정식+방자네추어탕",
      "휴게소전화번호": "063-631-2020",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "춘향(완주)",
      "도로종류": "고속국도",
      "도로노선번호": 27,
      "도로노선명": "순천완주선",
      "도로노선방향": "상행",
      "위도": 35.3376914,
      "경도": 127.3537495,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29675,
      "주차면수": 180,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "향단이정식+방자네추어탕",
      "휴게소전화번호": "063-635-6688",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "충주(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "상행",
      "위도": 37.023175,
      "경도": 127.839297,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 45558,
      "주차면수": 237,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "얼큰새뱅이해물순두부",
      "휴게소전화번호": "043-857-9229",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "충주(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "하행",
      "위도": 37.022229,
      "경도": 127.837071,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 22467,
      "주차면수": 261,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "충주사과수제돈가스",
      "휴게소전화번호": "043-857-9339",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "치악(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "상행",
      "위도": 37.253647,
      "경도": 128.048514,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 23752,
      "주차면수": 156,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "산나물만두감자옹심이",
      "휴게소전화번호": "033-762-9234",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "황간(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.248899,
      "경도": 127.8526701,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28345,
      "주차면수": 119,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "영표국밥＆솥밥",
      "휴게소전화번호": "043-742-5805",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "치악(춘천)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "하행",
      "위도": 37.256692,
      "경도": 128.0488701,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 44617,
      "주차면수": 149,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "치악산큰송이닭곰탕",
      "휴게소전화번호": "033-762-8030",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "칠곡(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.019795,
      "경도": 128.428517,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 24871,
      "주차면수": 334,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "칠곡호국부대찌개",
      "휴게소전화번호": "054-975-2277",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "칠곡(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.012005,
      "경도": 128.4308001,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 25690,
      "주차면수": 231,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "대구따로국밥",
      "휴게소전화번호": "054-975-1883",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "칠서(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 451,
      "도로노선명": "중부내륙지선",
      "도로노선방향": "상행",
      "위도": 35.3708801,
      "경도": 128.496807,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 22467,
      "주차면수": 128,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "소고기국밥",
      "휴게소전화번호": "055-587-9656",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "통도사(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 35.488841,
      "경도": 129.090775,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29882,
      "주차면수": 251,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "1등급한우국밥",
      "휴게소전화번호": "055-383-6145",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "평사(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 35.885522,
      "경도": 128.867541,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 63813,
      "주차면수": 243,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "경산대추비빔밥",
      "휴게소전화번호": "053-852-8651",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "평창(강릉)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "하행",
      "위도": 37.6055701,
      "경도": 128.452681,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 61050,
      "주차면수": 195,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "평창한우불고기비빔밥",
      "휴게소전화번호": "033-334-5100",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "평창(인천)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "상행",
      "위도": 37.610876,
      "경도": 128.463363,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 20787,
      "주차면수": 230,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "평창한우국밥",
      "휴게소전화번호": "033-333-6131",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "평택",
      "도로종류": "고속국도",
      "도로노선번호": 40,
      "도로노선명": "평택제천선",
      "도로노선방향": "양방향",
      "위도": 37.045585,
      "경도": 126.943774,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29993,
      "주차면수": 735,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "평택나루사골우거지국밥",
      "휴게소전화번호": "031-683-4800",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "하남드림",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "양방향",
      "위도": 37.530281,
      "경도": 127.206084,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 50294,
      "주차면수": 725,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "하남마방장터국밥",
      "휴게소전화번호": "031-791-4200",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함안(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "상행",
      "위도": 35.294068,
      "경도": 128.346957,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 47179,
      "주차면수": 281,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "연잎등심돈가스",
      "휴게소전화번호": "055-582-2191",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함안(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 10,
      "도로노선명": "남해선",
      "도로노선방향": "하행",
      "위도": 35.294701,
      "경도": 128.344767,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 26068,
      "주차면수": 272,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "N",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "돼지짜글이백반",
      "휴게소전화번호": "055-582-5470",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함양(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "상행",
      "위도": 35.551611,
      "경도": 127.7604201,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 46847,
      "주차면수": 91,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "새싹삼비빔밥",
      "휴게소전화번호": "055-963-8001",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함양(통영)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "하행",
      "위도": 35.551322,
      "경도": 127.758563,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 202440,
      "주차면수": 117,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "새싹삼비빔밥",
      "휴게소전화번호": "055-963-6717",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함평나비(광주)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "무안광주선",
      "도로노선방향": "상행",
      "위도": 35.037283,
      "경도": 126.511676,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 21068,
      "주차면수": 148,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "사골김치찌개+황태해장국",
      "휴게소전화번호": "061-324-8840",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함평나비(무안)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "무안광주선",
      "도로노선방향": "하행",
      "위도": 35.038198,
      "경도": 126.508813,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 47569,
      "주차면수": 148,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "순두부청국장+등심돈까스",
      "휴게소전화번호": "061-324-8858",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함평천지(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 35.069687,
      "경도": 126.478247,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 54324,
      "주차면수": 101,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "나주곰탕+순두부찌개",
      "휴게소전화번호": "061-323-3751",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "함평천지(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 35.130746,
      "경도": 126.482295,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 49784,
      "주차면수": 126,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "친환경 우렁 강된장 볶음+몽글몽글 순두부찌개",
      "휴게소전화번호": "061-323-3641",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "행담도",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "양방향",
      "위도": 36.944819,
      "경도": 126.807525,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42203,
      "주차면수": 627,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "Y",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "전주양반비빔밥",
      "휴게소전화번호": "041-358-0700",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "현풍(대구)",
      "도로종류": "고속국도",
      "도로노선번호": 451,
      "도로노선명": "중부내륙지선",
      "도로노선방향": "상행",
      "위도": 35.701841,
      "경도": 128.4381001,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42378,
      "주차면수": 131,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "현풍돼지불고기백반",
      "휴게소전화번호": "053-615-0337",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "현풍(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 451,
      "도로노선명": "중부내륙지선",
      "도로노선방향": "하행",
      "위도": 35.701783,
      "경도": 128.435359,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 23928,
      "주차면수": 91,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "현풍고추장불고기백반",
      "휴게소전화번호": "053-614-2436",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "홍성(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 36.552584,
      "경도": 126.579514,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 64043,
      "주차면수": 163,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "홍성반상한우국밥",
      "휴게소전화번호": "041-642-1151",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "홍성(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 36.5524301,
      "경도": 126.5818701,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 81664,
      "주차면수": 147,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "홍성반상한우국밥",
      "휴게소전화번호": "041-642-1172",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "홍천(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 60,
      "도로노선명": "서울양양선",
      "도로노선방향": "상행",
      "위도": 37.758898,
      "경도": 128.0065801,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 55517,
      "주차면수": 255,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "중화비빔밥",
      "휴게소전화번호": "033-436-9000",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "홍천(양양)",
      "도로종류": "고속국도",
      "도로노선번호": 60,
      "도로노선명": "서울양양선",
      "도로노선방향": "하행",
      "위도": 37.757369,
      "경도": 128.003099,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 43386,
      "주차면수": 209,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "홍천닭갈비화로구이",
      "휴게소전화번호": "033-436-3000",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "홍천강(춘천)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "상행",
      "위도": 37.712386,
      "경도": 127.827719,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 32652,
      "주차면수": 127,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "얼큰황태순두부_주물솥밥",
      "휴게소전화번호": "033-435-1201",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "화서(영덕)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "상행",
      "위도": 36.444053,
      "경도": 127.922637,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 26097,
      "주차면수": 225,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "제육볶음",
      "휴게소전화번호": "054-531-1982",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "화성(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 37.143612,
      "경도": 126.8790801,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 34013,
      "주차면수": 381,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "화성궁중비빔밥",
      "휴게소전화번호": "031-353-8140",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "화성(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 37.143497,
      "경도": 126.881289,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 47509,
      "주차면수": 444,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "순두부청국장",
      "휴게소전화번호": "031-353-8143",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "강릉(강릉)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "하행",
      "위도": 37.758206,
      "경도": 128.806648,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 85218,
      "주차면수": 244,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "뚝배기불고기",
      "휴게소전화번호": "033-648-8850",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "강릉(인천)",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "상행",
      "위도": 37.760275,
      "경도": 128.8053601,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 71026,
      "주차면수": 274,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "초당몽글순두부+초당두부황태해장국",
      "휴게소전화번호": "033-647-9970",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "강천산(광주)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "하행",
      "위도": 35.3657501,
      "경도": 127.105451,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 17767,
      "주차면수": 95,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "순창고추장 돌솥비빔밥+차돌박이 된장찌개",
      "휴게소전화번호": "063-653-4033",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "강천산(대구)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "상행",
      "위도": 35.364369,
      "경도": 127.104757,
      "휴게소종류": "간이휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 12365,
      "주차면수": 70,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "순창고추장 돌솥비빔밥+차돌박이 된장찌개",
      "휴게소전화번호": "063-653-3050",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "거창(광주)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "하행",
      "위도": 35.708862,
      "경도": 128.057962,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 56462,
      "주차면수": 106,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "돼지고기김치찌개",
      "휴게소전화번호": "055-943-0992",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "거창(대구)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "상행",
      "위도": 35.706469,
      "경도": 128.056945,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 56462,
      "주차면수": 92,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "왕돈가스",
      "휴게소전화번호": "055-943-9534",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "건천(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 35.830716,
      "경도": 129.1093101,
      "휴게소종류": "간이휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 13041,
      "주차면수": 120,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "누구나돌솥비빔밥",
      "휴게소전화번호": "054-751-6890",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "건천(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 35.831894,
      "경도": 129.109244,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 23174,
      "주차면수": 96,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "건천버섯차돌된장찌개",
      "휴게소전화번호": "054-751-7401",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "경산(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 35.879323,
      "경도": 128.810331,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 40171,
      "주차면수": 253,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "돼지갈비정식",
      "휴게소전화번호": "053-852-5243",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "경주(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 35.724761,
      "경도": 129.1929501,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 72848,
      "주차면수": 294,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "경주천년한우국밥",
      "휴게소전화번호": "054-748-3195",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "고성공룡나라(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "상행",
      "위도": 35.056665,
      "경도": 128.252359,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 50422,
      "주차면수": 148,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "꼬막비빔밥",
      "휴게소전화번호": "055-674-0494",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "고성공룡나라(통영)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "하행",
      "위도": 35.0518101,
      "경도": 128.262763,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42488,
      "주차면수": 161,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "해물순두부",
      "휴게소전화번호": "055-674-7028",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "고창고인돌(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 35.468653,
      "경도": 126.673871,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 52451,
      "주차면수": 294,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "고창장어탕",
      "휴게소전화번호": "063-561-6313",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "고창고인돌(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 35.4620701,
      "경도": 126.673477,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 114191,
      "주차면수": 259,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "장어탕",
      "휴게소전화번호": "063-561-6323",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "곡성(순천)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "하행",
      "위도": 35.258498,
      "경도": 127.150737,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 16137,
      "주차면수": 140,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "입맛없을땐 짜글이+흑돼지 김치찌개",
      "휴게소전화번호": "061-363-2766",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "곡성(천안)",
      "도로종류": "고속국도",
      "도로노선번호": 25,
      "도로노선명": "호남선",
      "도로노선방향": "상행",
      "위도": 35.259632,
      "경도": 127.152741,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 24680,
      "주차면수": 123,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "제육덮밥+사골우거지국밥",
      "휴게소전화번호": "061-362-8300",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "공주(당진)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "하행",
      "위도": 36.498679,
      "경도": 127.164921,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 52144,
      "주차면수": 184,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "공주알밤돌솥비빔밥",
      "휴게소전화번호": "041-854-0050",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "공주(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 30,
      "도로노선명": "당진영덕선",
      "도로노선방향": "상행",
      "위도": 36.496946,
      "경도": 127.1666701,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 49748,
      "주차면수": 193,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "공주알밤돌솥비빔밥",
      "휴게소전화번호": "041-854-6060",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "괴산(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "상행",
      "위도": 36.831894,
      "경도": 127.960141,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 38776,
      "주차면수": 189,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "엄나무닭곰탕",
      "휴게소전화번호": "043-832-6595",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "괴산(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "하행",
      "위도": 36.831456,
      "경도": 127.957845,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 37162,
      "주차면수": 264,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "괴산짜글이찌개",
      "휴게소전화번호": "043-832-7966",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "구리(일산)",
      "도로종류": "고속국도",
      "도로노선번호": 100,
      "도로노선명": "수도권제1순환선",
      "도로노선방향": "하행",
      "위도": 37.628023,
      "경도": 127.139237,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 19500,
      "주차면수": 149,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "초당해물순두부",
      "휴게소전화번호": "031-529-3564",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "구정(삼척)",
      "도로종류": "고속국도",
      "도로노선번호": 65,
      "도로노선명": "동해선",
      "도로노선방향": "하행",
      "위도": 37.722214,
      "경도": 128.8511601,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 41920,
      "주차면수": 241,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "통등심돈까스",
      "휴게소전화번호": "033-644-8345",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "구정(속초)",
      "도로종류": "고속국도",
      "도로노선번호": 65,
      "도로노선명": "동해선",
      "도로노선방향": "상행",
      "위도": 37.723012,
      "경도": 128.854228,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 52345,
      "주차면수": 150,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "옛날돈까스",
      "휴게소전화번호": "033-644-4760",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "군산(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 35.980591,
      "경도": 126.828971,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 14071,
      "주차면수": 151,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "해장아욱국밥",
      "휴게소전화번호": "063-453-0402",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "군산(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 36.018831,
      "경도": 126.797698,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 50249,
      "주차면수": 212,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "Y",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "불고기비빔밥",
      "휴게소전화번호": "063-453-2818",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "군위(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "하행",
      "위도": 36.266556,
      "경도": 128.574852,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 36839,
      "주차면수": 157,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "강된장비빔밤",
      "휴게소전화번호": "054-383-6114",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "군위(춘천)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "상행",
      "위도": 36.266002,
      "경도": 128.576774,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 39273,
      "주차면수": 154,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "강된장비빔밤",
      "휴게소전화번호": "054-383-7114",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "금강(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.279148,
      "경도": 127.672231,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 17409,
      "주차면수": 314,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "도리뱅뱅정식",
      "휴게소전화번호": "043-731-2233",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "금산인삼랜드(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "상행",
      "위도": 36.154689,
      "경도": 127.497681,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 40492,
      "주차면수": 187,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "인삼갈비탕",
      "휴게소전화번호": "041-754-9200",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "금산인삼랜드(통영)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "하행",
      "위도": 36.152874,
      "경도": 127.495954,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 48351,
      "주차면수": 237,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "Y",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "인삼능이왕갈비탕",
      "휴게소전화번호": "041-751-2892",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "금왕(제천)",
      "도로종류": "고속국도",
      "도로노선번호": 40,
      "도로노선명": "평택제천선",
      "도로노선방향": "하행",
      "위도": 36.9694501,
      "경도": 127.590845,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42829,
      "주차면수": 93,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "금왕인삼솥비빔밥",
      "휴게소전화번호": "043-881-0001",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "금왕(평택)",
      "도로종류": "고속국도",
      "도로노선번호": 40,
      "도로노선명": "평택제천선",
      "도로노선방향": "상행",
      "위도": 36.970655,
      "경도": 127.589499,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 42627,
      "주차면수": 100,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "금왕인삼불고기",
      "휴게소전화번호": "043-877-7000",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "기흥(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 37.235125,
      "경도": 127.104595,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 72615,
      "주차면수": 446,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "옛날흑돼지돈가스",
      "휴게소전화번호": "031-286-5001",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "김천(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.129252,
      "경도": 128.164782,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 45224,
      "주차면수": 188,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "대구궁중육개장",
      "휴게소전화번호": "054-435-0211",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "김천(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "상행",
      "위도": 36.131107,
      "경도": 128.164009,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 30577,
      "주차면수": 163,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "지례흑돼지제육�쳄�",
      "휴게소전화번호": "054-433-1523",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "김해금관가야",
      "도로종류": "고속국도",
      "도로노선번호": 600,
      "도로노선명": "부산외곽선",
      "도로노선방향": "양방향",
      "위도": 35.269933,
      "경도": 129.003134,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 52100,
      "주차면수": 356,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "제육덮밥",
      "휴게소전화번호": "055-312-2820",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "남성주참외(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "상행",
      "위도": 35.858422,
      "경도": 128.319904,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 39978,
      "주차면수": 139,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "화덕흑돼지불고기",
      "휴게소전화번호": "054-931-5741",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "남성주참외(창원)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "하행",
      "위도": 35.869015,
      "경도": 128.316816,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 38447,
      "주차면수": 147,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "화덕흑돼지불고기",
      "휴게소전화번호": "054-933-7105",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "내린천",
      "도로종류": "고속국도",
      "도로노선번호": 60,
      "도로노선명": "서울양양선",
      "도로노선방향": "양방향",
      "위도": 37.916535,
      "경도": 128.286377,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 88867,
      "주차면수": 555,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "용대리황태국밥",
      "휴게소전화번호": "033-852-8602",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "논공(광주)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "하행",
      "위도": 35.767421,
      "경도": 128.403493,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 29234,
      "주차면수": 119,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "대구육개장",
      "휴게소전화번호": "070-4304-0600",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "논공(대구)",
      "도로종류": "고속국도",
      "도로노선번호": 12,
      "도로노선명": "광주대구선",
      "도로노선방향": "상행",
      "위도": 35.764989,
      "경도": 128.402909,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 37766,
      "주차면수": 116,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "대구 연근덮밥",
      "휴게소전화번호": "070-4304-0620",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "단양팔경(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "상행",
      "위도": 36.995459,
      "경도": 128.287616,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 31481,
      "주차면수": 141,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "새뱅이해물순두부",
      "휴게소전화번호": "043-423-5401",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "단양팔경(춘천)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "하행",
      "위도": 36.942903,
      "경도": 128.322142,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 79980,
      "주차면수": 142,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "마늘왕돈가스",
      "휴게소전화번호": "043-421-1671",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "대천(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 36.372995,
      "경도": 126.555684,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 38519,
      "주차면수": 180,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "순두부찌개",
      "휴게소전화번호": "041-931-6901",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "대천(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 36.374457,
      "경도": 126.558327,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 49169,
      "주차면수": 211,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "돌솥비빔밥",
      "휴게소전화번호": "041-931-6801",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "덕유산(대전)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "상행",
      "위도": 35.816481,
      "경도": 127.646149,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 43941,
      "주차면수": 191,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "흑돼지김치찌개",
      "휴게소전화번호": "063-353-4200",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "덕유산(통영)",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "대전통영선",
      "도로노선방향": "하행",
      "위도": 35.813428,
      "경도": 127.643173,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 47737,
      "주차면수": 207,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "한우국밥",
      "휴게소전화번호": "063-353-5100",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "덕평",
      "도로종류": "고속국도",
      "도로노선번호": 50,
      "도로노선명": "영동선",
      "도로노선방향": "양방향",
      "위도": 37.241456,
      "경도": 127.390189,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 182761,
      "주차면수": 848,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "새우로제파스타",
      "휴게소전화번호": "031-645-0001",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "동명(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "하행",
      "위도": 36.0069901,
      "경도": 128.546504,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28095,
      "주차면수": 165,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "팔공비빔밤정식",
      "휴게소전화번호": "054-977-6922",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "동명(춘천)",
      "도로종류": "고속국도",
      "도로노선번호": 55,
      "도로노선명": "중앙선",
      "도로노선방향": "상행",
      "위도": 36.006426,
      "경도": 128.5493901,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 28096,
      "주차면수": 140,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "돌솥비빔밥된장찌게정식",
      "휴게소전화번호": "054-977-6901",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "동해(삼척)",
      "도로종류": "고속국도",
      "도로노선번호": 65,
      "도로노선명": "동해선",
      "도로노선방향": "하행",
      "위도": 37.601776,
      "경도": 129.073636,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 39724,
      "주차면수": 104,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "제육볶음",
      "휴게소전화번호": "033-534-6631",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "마장",
      "도로종류": "고속국도",
      "도로노선번호": 35,
      "도로노선명": "중부선",
      "도로노선방향": "양방향",
      "위도": 37.263849,
      "경도": 127.407043,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 103000,
      "주차면수": 693,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "이천돌솥밥설렁탕",
      "휴게소전화번호": "031-630-0001",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "망향(부산)",
      "도로종류": "고속국도",
      "도로노선번호": 1,
      "도로노선명": "경부선",
      "도로노선방향": "하행",
      "위도": 36.8556501,
      "경도": 127.180929,
      "휴게소종류": "일반휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 34779,
      "주차면수": 329,
      "경정비가능여부": "Y",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "명품한우국밥",
      "휴게소전화번호": "041-557-4000",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "매송(목포)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "하행",
      "위도": 37.265084,
      "경도": 126.888544,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 80395,
      "주차면수": 394,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "양갑조국밥",
      "휴게소전화번호": "031-296-1501",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "매송(서울)",
      "도로종류": "고속국도",
      "도로노선번호": 15,
      "도로노선명": "서해안선",
      "도로노선방향": "상행",
      "위도": 37.264769,
      "경도": 126.891795,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 87552,
      "주차면수": 396,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "N",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "N",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "양갑조국밥",
      "휴게소전화번호": "031-295-1501",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  },
  {
      "휴게소명": "문경(양평)",
      "도로종류": "고속국도",
      "도로노선번호": 45,
      "도로노선명": "중부내륙선",
      "도로노선방향": "상행",
      "위도": 36.621068,
      "경도": 128.1523901,
      "휴게소종류": "화물차휴게소",
      "휴게소운영시작시각": "00:00",
      "휴게소운영종료시각": "23:59",
      "도로점용면적": 19800,
      "주차면수": 301,
      "경정비가능여부": "N",
      "주유소유무": "Y",
      "LPG충전소유무": "Y",
      "전기차충전소유무": "Y",
      "버스환승가능여부": "N",
      "쉼터유무": "Y",
      "화장실유무": "Y",
      "약국유무": "N",
      "수유실유무": "Y",
      "매점유무": "Y",
      "음식점유무": "Y",
      "기타편의시설": "",
      "휴게소대표음식명": "짬뽕순두부",
      "휴게소전화번호": "054-554-1610",
      "데이터기준일자": "2024-05-24",
      "제공기관코드": "B500004",
      "제공기관명": "한국도로공사"
  }
]
  